import React from 'react';

import { routerHooks } from '../../hooks/routerHooks/routerHooks';

export const hooks = {
  useScrollOnPathChange(path: string | null) {
    React.useEffect(() => {
      if (!path) {
        return;
      }
      window && window.scrollTo(0, 0);
    }, [path]);
  },
  useScrollOnParamsChange(
    params: Record<string, string> | null,
    prevParams: React.MutableRefObject<Record<string, string>>,
  ) {
    React.useEffect(() => {
      if (!params) {
        return;
      }
      const paramsKeys = Object.keys(params);
      const prevParamsKeys = Object.keys(prevParams.current);
      let paramsChanged = false;
      const allKeys = new Set([...paramsKeys, ...prevParamsKeys]);
      for (const param of allKeys) {
        if (param === 'page') {
          continue;
        }
        if (params[param] !== prevParams.current[param]) {
          paramsChanged = true;
          break;
        }
      }

      prevParams.current = params;

      if (paramsChanged) {
        window && window.scrollTo(0, 0);
      }
    }, [params, prevParams]);
  },
};

export const ScrollToTop = React.memo(() => {
  const path = routerHooks.usePath();
  hooks.useScrollOnPathChange(path);

  const params = routerHooks.useParams();
  const prevParams = React.useRef<Record<string, string>>({});
  hooks.useScrollOnParamsChange(params, prevParams);

  return null;
});

ScrollToTop.displayName = 'ScrollToTop';
